<template>
    <section class="home-container">
        <MasterPage title="饮食日志">
            <div slot="title-icon">
                <Icon type="ios-restaurant" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="12">
                        <FormItem label="患者账号：">
                            <Select v-model="select.userId" filterable clearable placeholder="请选择">
                                <Option v-for="item in userAllList" :value="item.id" :key="item.id">{{ item.name }} - {{item.phone}}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <!--<Col span="12">-->
                        <!--<FormItem label="日志类型：">-->
                            <!--<Select v-model="select.type" placeholder="请选择">-->
                                <!--<Option value="早餐">早餐</Option>-->
                                <!--<Option value="午餐" >午餐</Option>-->
                                <!--<Option value="晚餐" >晚餐</Option>-->
                            <!--</Select>-->
                        <!--</FormItem>-->
                        <!--</Col>-->
                        <Col span="12">
                        <FormItem label="日志时间：">
                            <DatePicker v-model="select.date" type="date" clearable placeholder="请选择" style="width: 100%"></DatePicker>
                        </FormItem>
                        </Col>
                        <!--<Col span="8">-->
                        <!--<FormItem label="日志状态：">-->
                            <!--<Select v-model="select.isDeleted" @on-change="pageNum = 1" placeholder="请选择">-->
                                <!--<Option value="false">启用</Option>-->
                                <!--<Option value="true" >禁用</Option>-->
                            <!--</Select>-->
                        <!--</FormItem>-->
                        <!--</Col>-->
                    </Row>
                </Form>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="searchLogs">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="infoModel" title="日志详情">
            <Form :label-width="100">
                <FormItem  label="患者账号：">
                    <span v-if="item.id == infoItem.userId" v-for="item in userAllList" :key="item.id">{{item.name}}</span>
                </FormItem>
                <FormItem label="填写时间：">
                    {{infoItem.date | dateTimeToString}}
                </FormItem>
                <FormItem label="日志类型：">
                    {{infoItem.weekTime}}
                </FormItem>
                <FormItem label="日志食材：">
                    <Table max-height="300" stripe :columns="foodInfo" :data="infoItem.dietLogInfoList"></Table>
                </FormItem>
            </Form>
        </Modal>
        <Modal v-model="todayInfoModel" title="当日详情" >
            <Form :label-width="100">
                <FormItem  label="患者账号：">
                    <span v-if="item.id == infoItem.userId" v-for="item in userAllList" :key="item.id">{{item.name}}</span>
                </FormItem>
                <FormItem label="填写时间：">
                    {{infoItem.date | dateTimeToString}}
                </FormItem>
                <FormItem label="日志食材：">
                </FormItem>
                <Table max-height="300" stripe :columns="todayFoodInfo" :data="todayLogs"></Table>
            </Form>
        </Modal>
    </section>
</template>

<script>
    import Moment from 'moment'
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                moment: Moment,
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '用户患者',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            for (let i = 0 ; i < this.userAllList.length ; i++ ){
                                let user = this.userAllList[i]
                                if (user.id == params.row.userId){
                                    return h('span', user.name)
                                }
                            }
                        }
                    },
                    {
                        title: '星期',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let weekList = {0:'天',1:'一',2:'二',3:'三',4:'四',5:'五',6:'六',}
                            // let timeLits = {1:'早',2:'中',3:'晚',4:'晚加', 5: '上午加', 6: '下午加'}
                            // if (params.row.type.split("").length == 2){
                            //     let week = params.row.type.split("")[0]
                            //     let time = params.row.type.split("")[1]
                            //     this.dataList[params.index]['weekTime'] = "星期"+weekList[week] + " " +timeLits[time] +"餐"
                            //     return h('span',"星期"+weekList[week] + " " +timeLits[time] +"餐" )
                            // }
                            let week = this.moment(params.row.date).day()
                            return h('span',"星期"+weekList[week])
                        }
                    },
                    {
                        title: '填写时间',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let value = params.row.date
                            if (value==undefined || value.length <=0)return h('span', '-')
                            // let time = new Date(value)
                            // let y = time.getFullYear();
                            // let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                            // let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                            // let hs = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                            // let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                            // let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                            // return h('span', y+'-'+m+'-'+d+' '+hs+':'+mm+':'+s)
                            const time = this.moment(value).utcOffset(8).format('YYYY-MM-DD')
                            return h('span', time)
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let Buttons = [
                                // h('Button', {
                                //     props: {
                                //         type: 'primary',
                                //         icon:'ios-list-box',
                                //         label:"small",
                                //     },
                                //     style: {
                                //         marginRight: '5px'
                                //     },
                                //     on: {
                                //         click: () => {
                                //             this.infoItem_modal(this.dataList[params.index])
                                //         }
                                //     }
                                // }, '详情'),
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.todayInfoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情')
                            ]
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                foodInfo:[
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '食材名称',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        key:'foodName'
                    },
                    {
                        title: '食材数量',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            return h('span',params.row.value+params.row.foodUnit)
                        }
                    },
                ],
                todayFoodInfo: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '日志类型',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        key:'type',
                        render: (h, params) => {
                            let weekList = {0:'天',1:'一',2:'二',3:'三',4:'四',5:'五',6:'六',}
                            let timeLits = {1:'早',2:'中',3:'晚',4:'晚加', 5: '上午加', 6: '下午加'}
                            if (params.row.type.split("").length == 2){
                                let week = params.row.type.split("")[0]
                                let time = params.row.type.split("")[1]
                                // this.dataList[params.index]['weekTime'] = "星期"+weekList[week] + " " +timeLits[time] +"餐"
                                return h('span',"星期"+weekList[week] + " " +timeLits[time] +"餐" )
                            }
                            return h('span', '未知')
                        }
                    },
                    {
                        title: '食材名称',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        key:'foodName'
                    },
                    {
                        title: '食材数量',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            return h('span',params.row.value+params.row.foodUnit)
                        }
                    },
                ],
                tableLoading:false,
                infoModel:false,
                userAllList:[],
                select:{
                    userId:'',
                    type:'',
                    date:'',
                    isDeleted:'false',
                },
                infoItem:'',
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                todayLogs: [],
                todayInfoModel: false
            }
        },
        created(){
            this.pageFindItem()
            this.findAllUser()
        },
        methods:{
            searchLogs() {
                this.pageNum = 1
                this.pageFindItem()
            },
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            findAllUser(){
                this.$http.post('user/list',{
                    isLock:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.userAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('dietLog/userDayList',{
                    userId:this.select.userId == undefined ? "": this.select.userId,
                    type:this.select.type,
                    date:this.select.date == undefined || this.select.date == "" ? new Date(undefined):this.select.date+"",
                    isDeleted:this.select.isDeleted,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'饮食日志查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
            },
            todayInfoItem_modal(item){
                this.infoItem = item
                this.todayLogs = []
                item.dietLogs.map(logs => {
                  return logs.dietLogInfoList.map(log => {
                    let temp = Object.assign(log, {
                      type: logs.type
                    })
                    this.todayLogs.push(temp)
                  })
                })
                this.todayInfoModel = true
            }
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>


